import { render } from "./AiReportDetailContainer.vue?vue&type=template&id=04d4b7bc&scoped=true&ts=true"
import script from "./AiReportDetailContainer.vue?vue&type=script&lang=ts"
export * from "./AiReportDetailContainer.vue?vue&type=script&lang=ts"

import "./AiReportDetailContainer.vue?vue&type=style&index=0&id=04d4b7bc&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-04d4b7bc"]])

export default __exports__